import { render, staticRenderFns } from "./MypageUserInitPage.vue?vue&type=template&id=6769d815&scoped=true"
import script from "./MypageUserInitPage.vue?vue&type=script&lang=ts"
export * from "./MypageUserInitPage.vue?vue&type=script&lang=ts"
import style0 from "./MypageUserInitPage.vue?vue&type=style&index=0&id=6769d815&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6769d815",
  null
  
)

export default component.exports